import { ZONE_CONFIG, getZoneConfig } from '@/data/zone-data';

const ZONE_DESCRIPTIONS: Record<string, string> = {
  northern_midwest: 'WI, MI, MN, IA — shorter growing season, later planting windows',
  mid_midwest_south: 'MO, KS, KY, TN, VA, IN, OH — moderate growing season',
  deep_south: 'AL, MS, GA, FL, TX — long growing season, earlier planting',
};

export function getZoneDisplayName(zoneKey: string): string {
  return getZoneConfig(zoneKey)?.name ?? '';
}

export function getZoneDescription(zoneKey: string): string {
  return ZONE_DESCRIPTIONS[zoneKey] ?? '';
}

export function getZoneStates(zoneKey: string): string[] {
  return getZoneConfig(zoneKey)?.states ?? [];
}

export function getAllZones(): { key: string; name: string; description: string; states: string[] }[] {
  return Object.entries(ZONE_CONFIG).map(([key, config]) => ({
    key,
    name: config.name,
    description: ZONE_DESCRIPTIONS[key] ?? '',
    states: config.states,
  }));
}
